<template>
  <div>
    <el-row :gutter="20" style="margin-bottom: 20px;">
      <el-col :span="16">
        <el-card>
          <div
            slot="header"
            class="clearfix"
          >
            <span>Kintlévőségek megyénként</span>
          </div>
          <chart />
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card style="min-height: 385px;">
          <div
            slot="header"
            class="clearfix"
          >
            <span>TOP 5 képviselő</span>
          </div>
          <user-list />
        </el-card>
      </el-col>
    </el-row>
    <el-card>
      <div
        slot="header"
        class="clearfix"
      >
        <span>Kintlévőségek üzletenként</span>
      </div>
      <div v-loading="loading" style="min-height: 81px;">
        <table-filter
          v-if="filterConfig"
          :config="filterConfig"
          action="outstanding/fetchAll"
        />

        <el-button
          style="float: right; margin-top: -90px;"
          :loading="downloadLoading"
          icon="el-icon-download"
          @click="download"
        >
          Letöltés
        </el-button>
      </div>
      <outstanding-list style="margin-top: 30px"/>
    </el-card>
  </div>
</template>

<script>
import Chart from '../../components/reports/outstandings/Chart';
import UserList from '../../components/reports/outstandings/UserList';
import OutstandingList from '../../components/reports/outstandings/List';
import TableFilter from '../../components/TableFilter';

export default {
  components: {
    Chart,
    UserList,
    OutstandingList,
    TableFilter,
  },
  data() {
    return {
      loading: false,
      filterConfig: null,
      downloadLoading: false,
    };
  },
  async mounted() {
    this.loading = true;
    await this.setConfig();
    this.loading = false;
  },
  methods: {
    async download() {
      this.downloadLoading = true;
      try {
        const excel = await axios({
          url: `api/reports/outstandings/download`,
          method: 'POST',
          responseType: 'blob',
          data: this.$store.getters['outstanding/filterString'],
        });
        saveAs(excel, `outstandings.xlsx`);
      } catch (e) {
      }
      this.downloadLoading = false;
    },

    async setConfig() {
      let users = this.$store.getters['user/users'];
      if (!users.length) {
        await this.$store.dispatch('user/fetchAll');
        users = this.$store.getters['user/users'];
      }
      let locations = this.$store.getters['location/locations'];
      if (!locations.length) {
        await this.$store.dispatch('location/fetchAll');
        locations = this.$store.getters['location/locations'];
      }
      this.filterConfig = [
        {
          type: 'select',
          options: users,
          name: 'representative_user',
          label: 'Képviselő',
          labelCallback: user => user && user.last_name + ' ' + user.first_name || '',
          valueKey: 'id',
          defaultSearch: true
        },
        {
          type: 'remote',
          name: 'customer',
          label: 'Partner',
          labelCallback: partner => partner && `#${partner.id} ${partner.company.name}` || '',
          valueKey: 'id',
          remoteSearchParam: 'name',
          remoteAction: 'partner/search',
        },
        {
          type: 'remote',
          name: 'shop_id',
          label: 'Üzlet',
          labelCallback: shop => shop && `#${shop.id} ${shop.name}` || '',
          valueKey: 'id',
          remoteSearchParam: 'name',
          remoteAction: 'shop/search',
        },
        {
          type: 'select',
          options: locations,
          name: 'location',
          label: 'Terület',
          labelCallback: location => location && location.value || '',
          valueKey: 'id',
        },
      ];
    }
  }
};
</script>
